import locale from "localization";

export const keyAccountSummaryColumn = [
  { key: "keyAccountName", text: locale.keyAccount },
  { key: "transactionCount", text: locale.noOfTransactions },
  { key: "totalAmount", text: locale.amount },
  {
    key: "discount",
    text: (
      <>
        {locale.discount} /<br /> {locale.premium}
      </>
    ),
  },
  { key: "vatExempt", text: locale.vatExempt },
  { key: "finalAmount", text: locale.finalAmount },
  { key: "actions", text: "" },
];
